<script lang="ts">
    export let text : string = 'Coming soon'
    export let className :string = ''
    export let theme : 'green' | 'purple' | 'green-dark' = 'purple'
</script>

<span 
    class="info-pill {className}" 
    class:info-pill--green={theme === 'green'}
    class:info-pill--green-dark={theme === 'green-dark'}>
    { text }
</span>

<style lang="postcss">

.info-pill {
    font-size:14px;
    font-weight:600;
    color:#c58fff;
    background-color:rgba(#c58fff, 0.2);
    padding:5px 10px;
    border-radius:12px;
    text-align: center;
}

.info-pill--green {
    color:#5cffe4;
    background-color:rgba(#41bfcb, 0.2);
}

.info-pill--green-dark {
    color:#34b96f;
    background-color:#e1f1e7;
}
</style>